export default __webpack_public_path__ + "static/media/progressbar_3.be4ca176.PNG";